import { render, staticRenderFns } from "./confirmUser.vue?vue&type=template&id=358bf08e"
import script from "./confirmUser.vue?vue&type=script&lang=js"
export * from "./confirmUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports